// @flow

import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {browserHistory} from 'react-router';

import {gt} from 'app/utils/i18n';

import {getKBEditPage, KB_DASHBOARD_URL} from 'app/urls';
import {DocHeaderStructure} from 'app/general/structures/DocHeader';
import {createFormErrorsContext, FormControlGroup} from 'app/general/forms';
import {getContentType} from 'app/utils/content-type';
import {capitalizeFirstLetter} from 'app/utils/strings';
import {AutoHeightTitleInput} from 'app/components/general/AutoHeightTitleInput';
import {createNewKB} from 'app/kbs/actions';
import type {KnowledgeBaseType} from 'app/kbs/types';
import type {FormErrorsProps} from 'app/general/forms';
import {SPPage} from 'app/general/structures/SPPage';
import {accountSettingsSelector} from 'app/settings/api';

type OwnProps = {||};

type StateProps = {|
  isPerUser: boolean,
|};

type DispatchProps = {|
  createNewKB: AsyncAction<typeof createNewKB, Promise<KnowledgeBaseType>>,
|};

type ConnectedProps = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

type Props = {|
  ...ConnectedProps,
  ...FormErrorsProps,
|};

type State = {
  name: string,
  creating: boolean,
};

class BaseNewKnowledgebasePage extends React.PureComponent<Props, State> {
  state = {
    name: '',
    creating: false,
  };

  componentDidMount() {
    const {isPerUser} = this.props;
    if (!isPerUser) {
      browserHistory.replace(KB_DASHBOARD_URL);
    }
  }

  handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    // $FlowFixMe
    const name = e.currentTarget['title'].value;

    if (this.state.creating) {
      return;
    }

    this.setState({creating: true});

    this.props
      .createNewKB({
        name,
        enabled: true,
      })
      .then(
        (kb) => browserHistory.push(getKBEditPage(kb.hashid)),
        (err) => {
          this.disableCreating();
          this.props.captureFormErrorsFromRejection(err);
          throw err;
        }
      );
  };

  disableCreating = () => this.setState({creating: false});

  render() {
    const {creating} = this.state;
    const docType = capitalizeFirstLetter(getContentType('knowledgebase').name);

    return (
      <SPPage
        pageTitle={gt('Create %(name)s', {name: docType})}
        breadcrumbProps={{ct: docType}}
      >
        <form onSubmit={this.handleSubmit}>
          <DocHeaderStructure
            titleContent={
              <h1>
                <FormControlGroup field="name">
                  <AutoHeightTitleInput
                    className="form-control"
                    autoFocus={true}
                    type="text"
                    maxLength={128}
                    name="title"
                    placeholder={gt('%(docType)s title', {docType})}
                  />
                </FormControlGroup>
              </h1>
            }
            extraContent={
              <div className="text-right">
                <button
                  type="submit"
                  className={classNames('btn', 'btn-primary', {
                    disabled: creating,
                  })}
                >
                  {creating ? gt('Creating') : gt('Continue')}
                </button>
              </div>
            }
          />
        </form>
      </SPPage>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  isPerUser: accountSettingsSelector(state).data.is_peruser,
});

// $FlowFixMe
const dispatchToProps: DispatchProps = {createNewKB};

export const NewKnowledgebasePage = connect<
  ConnectedProps,
  OwnProps,
  StateProps,
  DispatchProps,
  _,
  _
>(
  mapStateToProps,
  dispatchToProps
)(createFormErrorsContext<ConnectedProps>(BaseNewKnowledgebasePage));
